/**
 * Доступ к VITE_-переменным с дефолтами.
 * Все обращения к import.meta.env идут только отсюда — иначе сложно мокать в тестах.
 */
export const ENV = {
  API_BASE_URL: (import.meta.env.VITE_API_BASE_URL as string) ?? '',
  BOT_USERNAME: (import.meta.env.VITE_BOT_USERNAME as string) ?? 'lura_app_bot',
  TON_MANIFEST_URL: (import.meta.env.VITE_TON_MANIFEST_URL as string) ?? '',
  IS_DEV: import.meta.env.DEV,
} as const;
